import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    padding: '30px 15px 30px 15px;',
    display: 'inline-flex',
  },
  image: {
    width: '33%',
    height: '98px',
    backgroundColor: 'white',
    borderRadius: '20px 0px 0 20px',
  },
  content: {
    width: '67%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: '0px 20px 20px 0px',
    paddingTop: 15,
    paddingBottom: 20,
    marginLeft: -2,
  },
  imageIcon: {
    height: '100%',
    width: '100%',
    borderRadius: 20,
    padding: 10,
    objectFit: 'cover'
  },
  iconRoot: {
    textAlign: 'center',
  },
  title: {
    color: '#981248',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    fontStyle: 'italic',
    paddingRight: 10,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
    fontFamily: 'Roboto',
    fontSize: 10,
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
    color: '#273A42',
    paddingRight: 10,

    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
}));

const LatestNewsPreview = props => {
  const { className, news, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();

  return (
    <a href={news.url} className={clsx(classes.root, className)}>
      <div className={clsx(classes.image)}>
        <Icon classes={{ root: classes.iconRoot }}>
          <img
            className={clsx(classes.imageIcon)}
            alt="News preview"
            {...news.cover}
          />
        </Icon>
      </div>
      <div className={clsx(classes.content)}>
        <div className={clsx(classes.title)}>{news.title}</div>
        <div
          className={clsx(classes.description)}
          dangerouslySetInnerHTML={{
            __html: news.description,
          }}
        ></div>
      </div>
    </a>
  );
};

LatestNewsPreview.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * News informations
   */
  news: PropTypes.object.isRequired,
};

export default LatestNewsPreview;
